import { render } from "./transactionsList.vue?vue&type=template&id=454ea362&ts=true"
import script from "./transactionsList.vue?vue&type=script&lang=ts"
export * from "./transactionsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__